import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex flex-col pb-8" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "mt-6 rounded-xl bg-white p-3" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = {
  key: 0,
  class: "rounded px-2 py-0 bg-gray-lp-200 capitalize mt-1",
  style: {"width":"fit-content"}
}
const _hoisted_10 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col gap-3"
}
const _hoisted_12 = { class: "font-normal text-black-lp-300 text-xs mb-2" }
const _hoisted_13 = { class: "font-normal text-black-lp-300 text-xs mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_SavedPackageRow = _resolveComponent("SavedPackageRow")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0 break-all",
      onBack: _ctx.goBack,
      title: _ctx.$t('managementCustomer.detailTitle')
    }, {
      "top-right": _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_lp_button, {
            class: "whitespace-nowrap",
            customClass: "w-28",
            title: _ctx.$t('managementCustomer.delete'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDeleteModal())),
            textColor: "red-lp-300",
            outline: "",
            iconLeft: "trash-red"
          }, null, 8, ["title"]),
          _createVNode(_component_lp_button, {
            class: "whitespace-nowrap pl-4",
            customClass: "w-36",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToEdit())),
            title: _ctx.$t('managementCustomer.edit'),
            textColor: "white",
            iconV2: "",
            iconLeft: "save",
            disabled: _ctx.isErrorForm || _ctx.isSubmitLoading
          }, null, 8, ["title", "disabled"])
        ])
      ]),
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('managementCustomer.form.name'),
              class: "w-1/3 mr-2 break-all capitalize",
              value: _ctx.dataDetail.customerName
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('managementCustomer.form.phone'),
              class: "w-1/3 mr-2 ml-2 break-all",
              value: '+' + _ctx.dataDetail.customerPhoneNumber
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('managementCustomer.form.email'),
              class: "w-1/3 ml-2 break-all mr-6",
              value: _ctx.dataDetail.customerEmail
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('managementCustomer.form.commodity'),
              class: "w-1/3 ml-2 break-all mr-6",
              value: _ctx.dataDetail.customerCommodity.name
            }, null, 8, ["label", "value"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('managementCustomer.form.note'),
              class: "w-ful break-all mr-6",
              value: _ctx.dataDetail.customerNote
            }, null, 8, ["label", "value"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Tabs, {
              modelValue: _ctx.activeTab,
              data: _ctx.tabs,
              rounded: false,
              marginTop: "0",
              "onUpdate:modelValue": _ctx.onChangeTab
            }, null, 8, ["modelValue", "data", "onUpdate:modelValue"]),
            (_ctx.activeTab === 'alamat')
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('managementCustomer.form.address'),
                      class: "w-full break-all mr-6",
                      value: _ctx.dataDetail.customerAddress
                    }, null, 8, ["label", "value"])
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('managementCustomer.form.district'),
                      class: "w-1/3 mr-2 break-words",
                      value: _ctx.dataDetail.customerDistrictName
                    }, null, 8, ["label", "value"]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('managementCustomer.form.addressType'),
                      class: "w-1/3 mr-2 ml-2 break-all"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.dataDetail.customerAddressType)
                          ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.dataDetail.customerAddressType), 1))
                          : (_openBlock(), _createBlock("div", _hoisted_10, "-"))
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('managementCustomer.form.zipCode'),
                      class: "w-1/3 ml-2 break-all",
                      value: _ctx.dataDetail.customerZipCode
                    }, null, 8, ["label", "value"])
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_11, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.savedPackages, (pkg, idx) => {
                    return (_openBlock(), _createBlock(_component_SavedPackageRow, {
                      key: pkg.id,
                      index: idx + 1,
                      savedPackage: pkg
                    }, null, 8, ["index", "savedPackage"]))
                  }), 128)),
                  (!_ctx.isLoadingSavedPackage && !_ctx.savedPackages.length)
                    ? (_openBlock(), _createBlock(_component_EmptyState, {
                        key: 0,
                        icon: "noData_empty_new",
                        customHeaderMessage: _ctx.$t('managementCustomer.savedPackage.emptyTitle'),
                        customMessage: _ctx.$t('managementCustomer.savedPackage.emptyDescription'),
                        customClassImage: ""
                      }, null, 8, ["customHeaderMessage", "customMessage"]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode("div", null, [
          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("managementCustomer.createdAt")), 1),
          _createVNode(_component_DataWrapper, {
            class: "text-black-lp-200",
            customStyleValue: " font-semibold",
            value: 
            _ctx.formatDate(_ctx.dataDetail.customerCreatedAt) === '0001-01-01T00:00:00Z'
              ? '-'
              : _ctx.formatDate(_ctx.dataDetail.customerCreatedAt)
          
          }, null, 8, ["value"])
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("managementCustomer.updatedAt")), 1),
          _createVNode(_component_DataWrapper, {
            class: "text-black-lp-200",
            customStyleValue: " font-semibold",
            value: 
            _ctx.formatDate(_ctx.dataDetail.customerUpdatedAt) === '0001-01-01T00:00:00Z'
              ? '-'
              : _ctx.formatDate(_ctx.dataDetail.customerUpdatedAt)
          
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerDelete,
      onClose: _ctx.onCloseModalDelete,
      title: _ctx.$t('managementCustomer.deleteConfirmTitle'),
      message: _ctx.$t('managementCustomer.deleteConfirmMessage'),
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('managementCustomer.deleteConfirmSubmit'),
      textCancel: _ctx.$t('managementCustomer.back'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.openModalDelete]
    ])
  ], 64))
}